import { Action } from '@arra/core';
import styled from '@emotion/styled';
import { ReactElement } from 'react';

import CloudIcon from '../../ui/icons/categories/co2.png';
import WaterDropIcon from '../../ui/icons/categories/ressources.png';
import VolunteerActivismIcon from '../../ui/icons/categories/social-utility.png';
import { humanizeValue } from '../page/ActionCard';

const ActionWrapper = styled.div`
  padding: 6px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;

  > p {
    text-align: right;
  }
`;

const IconContainer = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
`;

const Title = styled.div`
  flex-grow: 1;
`;

interface ActionProps {
  action: Action;
  scope: string;
}

const scopeIcons: { [key: string]: ReactElement } = {
  utilite: (
    <img src={VolunteerActivismIcon} alt="utilite" style={{ width: '32px' }} />
  ),
  ressources: (
    <img src={WaterDropIcon} alt="ressources" style={{ width: '32px' }} />
  ),
  co2: <img src={CloudIcon} alt="co2" style={{ width: '32px' }} />,
};

const ActionRow = ({ action, scope }: ActionProps) => {
  const impact = action.impacts.find((impact) => impact.scope === scope);
  const icon = scopeIcons[scope] ?? <img src="/action.png" alt="action" />;
  const humanizedImpact = impact
    ? humanizeValue(impact.unit, impact.value, impact.scope)
    : null;

  return (
    <ActionWrapper>
      <IconContainer>{icon}</IconContainer>
      <Title className="hzr">{action.title}</Title>
      {humanizedImpact?.value && (
        <p className="hzr" style={{ whiteSpace: 'nowrap' }}>
          {`${humanizedImpact.value} ${humanizedImpact.unit}`.trim()}
        </p>
      )}
    </ActionWrapper>
  );
};

export default ActionRow;
